const en = {
  // Common translations
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  cancel: 'Cancel',
  confirm: 'Confirm',
  submit: 'Submit',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  close: 'Close',
  
  // Navigation
  home: 'Home',
  about: 'About',
  contact: 'Contact',
  services: 'Services',
  
  // Common phrases
  learnMore: 'Learn More',
  getStarted: 'Get Started',
  readMore: 'Read More',
  viewAll: 'View All',
};

export default en;